import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import type { OutlinedInputProps } from '@mui/material/OutlinedInput';

type Props = {
  onChange: (val: string) => void;
  value: string;
  placeHolder?: string;
};

const CustomName: React.FC<Props> = ({ onChange, value, placeHolder }) => {
  const [val, setVal] = useState<string>(value ?? '');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setVal(value ?? '');
  }, [value]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setVal(e.target.value);
  }, []);

  const handleBlur = useCallback(() => {
    onChange(val);
  }, [onChange, val]);

  const endAdornment = useMemo(
    () => (
      <InputAdornment position="end" sx={{ mr: 0.5 }}>
        <IconButton
          aria-label="edit"
          onClick={() => inputRef.current?.focus()}
          edge="end"
          size="small"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </InputAdornment>
    ),
    []
  );



  return (
    <TextField
      id="array-custom-name"
      className="custom-name-input"
      value={val}
      placeholder={placeHolder}
      variant="standard"
      fullWidth
      inputRef={inputRef}
      InputProps={{ endAdornment } as Partial<OutlinedInputProps>}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

export default React.memo(CustomName);
